import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { useCallback, useState } from 'react';
import FirebaseFunctions from '../services/FirebaseFunctions';

const methodName = 'v1_apitoken_delete' as const;

export type DeleteApiTokenResult = HttpsCallableResult<{ id: string }>
export type DeleteApiTokenData = {
  id: string,
};

export type DeleteApiToken = Readonly<[
  run: (data: DeleteApiTokenData) => Promise<DeleteApiTokenResult>,
  progress: boolean,
  err?: Error
]>;

export const useDeleteApiToken = (): DeleteApiToken => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const run = useCallback(
    async (data: DeleteApiTokenData): Promise<DeleteApiTokenResult> => {
      setLoading(true);
      setError(undefined);
      try {
        const callable = httpsCallable<
          { action: typeof methodName; data: DeleteApiTokenData },
          { id: string }
        >(FirebaseFunctions, 'app');
        return await callable({ action: methodName, data });
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    []
  );
  return [run, loading, error];
};
